import { useState } from 'react';
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Reference } from '../../../../interfaces';
import Tooltip from '../../../utils/Tooltip';

export interface Props {
    reference: Reference
}

export const ReferenceCard = ({ reference }: Props) => {
  const [showMessageCopy, setShowMessageCopy] = useState(false);

  const handleCopy = () => {
    setShowMessageCopy(true);
    setTimeout(() => {
      setShowMessageCopy(false);
    }, 1000);
  }

  return (
    <div className="card-reference">
      <div className="card-reference__source">
        {reference.content}
        {reference.url && (<a href={reference.url} target='_blank'> Disponible aquí</a>)}
      </div>
      <div className="card-reference__actions">
          <Tooltip tip="Copiar al portapapeles">
            <div>
              <CopyToClipboard text={reference.content} onCopy={() => handleCopy()}>
                <button type="button" className="btn btn-rounded btn-rounded-secondary tippy" data-tippy-content="Copiar al portapapeles" aria-label="Copiar referencia">
                  <span className="btn__icon"><i className="icon icon-copy"></i></span>
                </button>
              </CopyToClipboard>
            </div>
          </Tooltip>
          { showMessageCopy && (<div>Copiado</div>) }
      </div>
    </div>
  )
}